import React from "react";
import { useTranslation } from "react-i18next";

import {
  Image,
} from '@lockerpm/design';

const MissionStep = (props) => {
  const { t } = useTranslation();

  const {
    className,
    missionStep = {}
  } = props;

  return (
    <div className={`current-step flex items-center ${className}`}>
      <div
        className="mr-3 font-semibold"
        style={{ color: missionStep.color }}
      >
        {t(`rewards.${missionStep.value}`)}
      </div>
      <Image
        src={missionStep.icon}
        preview={false}
      />
    </div>
  );
}

export default MissionStep;